import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/routes/Home.jsx';

import Header from './components/common/Header.jsx';
import Footer from './components/common/Footer.jsx';
import Container from './components/common/Container.jsx';
import Message from './components/common/Message.jsx';
import Combos from './components/routes/Combos.jsx';

import Contracts from './components/routes/Contracts.jsx';
import ContactPage from './components/routes/ContactPage.jsx';

import { UserProvider } from './context/UserContext.js';

function App() {
  return (
    <Router>

      <UserProvider>

        <Header />

        <Message />

        <Container>

          <Routes>

            <Route path="/" element={<Home />} />


            <Route path="/contratos" element={<Contracts />} />

            <Route path="/combos" element={<Combos />} />


            <Route path="/contato" element={<ContactPage />} />

          </Routes>

        </Container>

        <Footer />

      </UserProvider>

    </Router>
  );
}

export default App;
